var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "136 -824 688 688",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m627.85-323.85 23.3-23.3L496-502.33V-720h-32v232.31zM480.13-136q-71.04 0-133.59-26.84t-109.68-73.92-73.99-109.72Q136-409.11 136-480.32q0-71.22 26.84-133.96 26.84-62.73 73.92-109.36t109.72-73.49Q409.11-824 480.32-824q71.22 0 133.96 27.08 62.75 27.08 109.16 73.5t73.49 109.18Q824-551.49 824-480.13q0 71.04-26.84 133.59t-73.42 109.68-109.39 73.99Q551.54-136 480.13-136m.35-32q129.47 0 220.5-91.5Q792-351 792-480.48q0-129.47-91.02-220.5Q609.95-792 480.48-792 351-792 259.5-700.98 168-609.95 168-480.48 168-351 259.5-259.5T480.48-168"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.6077f3a7e5dac1f90e4277ba2677dd00.svg";
export { ForwardRef as ReactComponent };